
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore, documentStore, configStore } from "@/store/store";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import ElementBadge from "./ElementBadge.vue";
import { getProBadge } from "@/lib/subscriptions/free-mode";

@Component({
  components: {
    Dropdown,
    IconButton,
    ElementBadge
  }
})
export default class Titlebar extends Vue {
  get elementTitle() {
    return uiStore.activeElement
      ? configStore.element(uiStore.activeElement.data.type).name
      : "No Active Element"; /* should never happen */
  }
  get elementBadges() {
    if (!uiStore.activeElement) return [];

    const element = configStore.element(uiStore.activeElement.data.type);

    const badges = element.badge ? [element.badge] : [];

    if (
      element.settings &&
      element.settings.proOnly &&
      configStore.subscriptionMode === "free"
    ) {
      badges.push(getProBadge());
    }

    return badges;
  }
  duplicateElement() {
    if (uiStore.activeElementId) {
      documentStore.duplicateElementAndActivateIt(uiStore.activeElementId);
    }
  }
  remove() {
    if (uiStore.activeElementId !== null) {
      documentStore.deleteElement({
        nodeId: uiStore.activeElementId
      });
    }
  }
}
